module.exports = __webpack_public_path__ + "static/media/aim.ca4d2ce5.png";